import { TextProps } from '@components/Text/Text';
import {
  IconButtonProps,
  SvgIconProps,
  TypographyProps,
  useTheme,
} from '@mui/material';
import React from 'react';
import {
  IconButtonText,
  StyledIconButton,
  StyledIconRoundBox,
} from './IconButton.style';

export type iconBoxColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'
  | undefined;

type iconModeType = 'dark' | 'light';

interface PropsType extends IconButtonProps {
  icon: (props: SvgIconProps) => JSX.Element;
  outline?: boolean;
  filled?: boolean;
  iconBoxWidth?: string | number;
  iconBoxHeight?: string | number;
  color?: iconBoxColor;
  iconType?: iconModeType;
  textProps?: TextProps & Omit<TypographyProps, 'fontWeight'>;
}

const IconButton: React.FC<PropsType> = ({
  children,
  textProps,
  outline,
  filled,
  iconBoxWidth = 38,
  iconBoxHeight = 38,
  color,
  iconType,
  icon: Icon,
  ...restProps
}) => {
  const theme = useTheme();
  return (
    <StyledIconButton {...restProps}>
      {Icon && (
        <StyledIconRoundBox
          outline={outline}
          width={iconBoxWidth}
          borderRadius={iconBoxWidth}
          height={iconBoxHeight}
          filled={filled}
          color={color}
        >
          <Icon
            style={{
              color:
                iconType === 'dark'
                  ? theme.palette.common.black
                  : iconType === 'light'
                  ? theme.palette.common.white
                  : theme.palette[color ?? 'primary'].main,
            }}
          />
        </StyledIconRoundBox>
      )}
      <IconButtonText
        variant='h6'
        fontWeight='fontWeightSemiBold'
        {...textProps}
      >
        {children}
      </IconButtonText>
    </StyledIconButton>
  );
};

export default IconButton;
